var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mt-10" }, [
    _c(
      "div",
      { staticClass: "bg-white shadow px-4 py-5 sm:rounded-lg sm:p-6" },
      [
        _c("div", { staticClass: "md:grid md:grid-cols-3 md:gap-6" }, [
          _c("div", { staticClass: "md:col-span-1" }, [
            _c(
              "h3",
              { staticClass: "text-lg font-medium leading-6 text-gray-900" },
              [_vm._v(" Welcome message ")]
            ),
            _c("p", { staticClass: "mt-1 text-sm leading-5 text-gray-500" }, [
              _vm._v(
                " Welcome message makes the chat button more noticeable to new visitors of your store. We only show once a day. "
              )
            ]),
            _c(
              "div",
              [_c("CalloutCardPreview", { attrs: { config: _vm.config } })],
              1
            )
          ]),
          _c("div", { staticClass: "md:col-span-2" }, [
            _c("fieldset", { staticClass: "mt-6" }, [
              _c(
                "legend",
                {
                  staticClass: "text-base leading-6 font-medium text-gray-900"
                },
                [_vm._v(" Enable Welcome message ")]
              ),
              _c(
                "div",
                { staticClass: "mt-4 flex flex-wrap" },
                [
                  _c("VSwitch", {
                    model: {
                      value: _vm.config.welcomeMessage.isEnabled,
                      callback: function($$v) {
                        _vm.$set(_vm.config.welcomeMessage, "isEnabled", $$v)
                      },
                      expression: "config.welcomeMessage.isEnabled"
                    }
                  })
                ],
                1
              )
            ]),
            _c("div", { staticClass: "mt-6" }, [
              _c("div", {}, [
                _c("div", { staticClass: "grid grid-cols-12 gap-6" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-span-12 sm:col-span-12 lg:col-span-12 relative"
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass:
                            "block text-sm font-medium leading-5 text-gray-700",
                          attrs: { for: "city" }
                        },
                        [_vm._v("Message text")]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.config.welcomeMessage.text,
                            expression: "config.welcomeMessage.text"
                          }
                        ],
                        staticClass:
                          "mt-1 form-input block w-full py-2 px-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5",
                        domProps: { value: _vm.config.welcomeMessage.text },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.config.welcomeMessage,
                              "text",
                              $event.target.value
                            )
                          }
                        }
                      }),
                      _vm.hasMoreCharacters
                        ? _c(
                            "p",
                            {
                              staticClass: "mt-2 text-sm text-red-600",
                              attrs: { id: "email-error" }
                            },
                            [
                              _vm._v(
                                " Button Label should be less than 40 characters "
                              )
                            ]
                          )
                        : _vm._e()
                    ]
                  )
                ])
              ])
            ]),
            _c("div", { staticClass: "mt-6" }, [
              _c("div", {}, [
                _c("div", { staticClass: "grid grid-cols-12 gap-6" }, [
                  _c(
                    "div",
                    {
                      staticClass:
                        "col-span-12 sm:col-span-12 lg:col-span-12 relative"
                    },
                    [
                      _c(
                        "label",
                        {
                          staticClass:
                            "block text-sm font-medium leading-5 text-gray-700",
                          attrs: { for: "city" }
                        },
                        [_vm._v("Message delay (in seconds)")]
                      ),
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.config.welcomeMessage.delay,
                            expression: "config.welcomeMessage.delay"
                          }
                        ],
                        staticClass:
                          "mt-1 form-input block w-full py-2 px-2 border border-gray-300 rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5",
                        attrs: { type: "number" },
                        domProps: { value: _vm.config.welcomeMessage.delay },
                        on: {
                          input: function($event) {
                            if ($event.target.composing) {
                              return
                            }
                            _vm.$set(
                              _vm.config.welcomeMessage,
                              "delay",
                              $event.target.value
                            )
                          }
                        }
                      })
                    ]
                  )
                ])
              ])
            ]),
            _c("div", { staticClass: "mt-8 border-t border-gray-200 pt-5" }, [
              _c("div", { staticClass: "flex justify-end" }, [
                _c(
                  "span",
                  { staticClass: "ml-3 inline-flex rounded-md shadow-sm" },
                  [
                    _c(
                      "button",
                      {
                        staticClass: "Polaris-Button Polaris-Button--primary",
                        attrs: { type: "submit" },
                        on: { click: _vm.save }
                      },
                      [_vm._m(0)]
                    )
                  ]
                )
              ])
            ])
          ])
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "Polaris-Button__Content" }, [
      _c("span", { staticClass: "Polaris-Button__Text" }, [_vm._v("Save")])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }